import { includes } from 'lodash/fp';

import ahmConstants from '../../../../../ahm-constants';
import type { Offer } from '../../../types';

const getFindCoverCtaContent = (offer: Offer) => {
  if (includes('extras-only', offer?.identifier?.current)) {
    return {
      name: 'Find extras only cover',
      url: ahmConstants.URLS.SALES.PRODUCT_LISTING_EXTRAS,
    };
  }

  if (includes('hospital-only', offer?.identifier?.current)) {
    return {
      name: 'Find hospital only cover',
      url: ahmConstants.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
    };
  }

  return {
    name: 'Find hospital and extras cover',
    url: ahmConstants.URLS.SALES.CHOOSE_YOUR_COVER_COMBINED_CHOOSE,
  };
};

export default getFindCoverCtaContent;
